module.exports = __webpack_public_path__ + "media/images/icons/brands/gulp-92ad8a5ef81280a0a7d269dc8adcf2e2.svg";